import { render, staticRenderFns } from "./SummaryOrder.vue?vue&type=template&id=3ef183db&scoped=true&"
import script from "./SummaryOrder.vue?vue&type=script&lang=ts&"
export * from "./SummaryOrder.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryOrder.vue?vue&type=style&index=0&id=3ef183db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef183db",
  null
  
)

export default component.exports